// extracted by mini-css-extract-plugin
export default {"googleButton":"OAuth_googleButton__3F+kS","googleIcon":"OAuth_googleIcon__ZEuf8","content":"OAuth_content__U46E1","slogan":"OAuth_slogan__2xRs2"};